<div id="content" class="container">
  <h1>AS568 O-Ring Size Chart & Dimensions</h1>
  <div class="row-column-responsive">
    <div>
      <p>
        USA AS568 o-ring standard sizes are the most commonly used o-ring sizes in the world. Refer to our standard
        o-ring size chart to find USA AS568 o-ring dimensions.
      </p>
      <p>
        Order o-rings online from the world’s largest inventory
        network including custom o-rings typically without tooling fees. O-ring tolerances vary by use, please refer to
        our <a href="/o-ring-tolerance-index.htm">o-ring tolerance pages</a> or contact us for responsive expert
        service.
      </p>
    </div>
    <img width="275" height="175" alt="O-ring Sizing Dimensions" src="/assets/site/images/oring-dimensions.webp">
  </div>
  <br>
  <ag-grid-component [browserCheck]="true" [rowData]="rowData" [colDefs]="colDefs"></ag-grid-component>
  <!-- <div class="m3-sizetable-container">
    <table class="m3-sizetable">
    <tbody #sizes *ngIf="isBrowser()">
      <tr *ngFor="let row of rowData">
        <td-value-with-links [value]="row.size" [link]="row.link" [params]="row.params"></td-value-with-links>
        <td>{{ row.size }}</td>
        <td>{{ row.csIn }}</td>
        <td>{{ row.idIn }}</td>
        <td>{{ row.odIn }}</td>
        <td>{{ row.csMm }}</td>
        <td>{{ row.idMm }}</td>
        <td>{{ row.odMm }}</td>
        <td>
          <a class="btn-quote" [href]="'/inquiry-quote.htm?dimensions=' + row.size"> Get
            Quote</a>
          <a class="btn-store" [href]="'/store/size/' + row.size">Buy Online</a>
        </td>
      </tr>

    </tbody>
    </table>   -->
  <br />
  <p>
    If you'd like to discuss your specialty application with a product expert, call us today at <a href="tel:6034683600" class="text-bold">(603) 468-3600</a>
  </p>
  <div class="add-flex flex-row">
    <div>
      <a href="/downloads/marco-o-ring-size-chart-as568.pdf" target="_blank" class="btn btn-primary text-white">Download
        Size Chart PDF</a>
    </div>
  </div>
  <br />
</div>
<app-related-links [columns]="'2'" [cards]="['nonstandard-oring-sizes', 'material-selection-guide', 'oring-groove-design-guide', 'contact-us']"></app-related-links>
